/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
import React from 'react';
import { ThemeProvider } from '../../../../../themes';
import Button from '../../../../../Button';
import IconFavorite from '../../../../../Icon/IconFavorite';

const icon = <IconFavorite />;

export default {
  id: 'themes',
  title: 'Example',
  description: `Themes are applied via the [ThemeProvider](/components/theme-provider) which by default uses the mineral theme.`,

  scope: { Button, icon, ThemeProvider },
  source: `
    <ThemeProvider>
      <Button primary iconStart={icon}>I like the default</Button>
    </ThemeProvider>
  `
};



// WEBPACK FOOTER //
// ./src/website/app/demos/themes/examples/themes.js